// UI glue of the metrics: computes the values for the configuration currently shown and writes them to the page.
// The metric definitions live in corrected.js; the layout in ../layout/layout.js.
import { addValuesToHistories } from '../sparkline.js';
import { computeLayout } from '../layout/layout.js';
import { metricColumn } from './directions.js';
import { DEFAULT_VERSION, evaluateAll } from './index.js';

const metricVersion = DEFAULT_VERSION;

function layoutOptions() {
    const svg = document.getElementById('vis-svg');
    return { width: +svg.getAttribute('width'), height: +svg.getAttribute('height') };
}

// Metrics of the configuration in window.psOrdering for the dataset in window.psDataset.
export function updateQmInfos() {
    return evaluateAll(window.psOrdering, window.psDataset, layoutOptions(), { version: metricVersion });
}

// Checks that the ribbons rendered by d3.parsets sit where the layout function, from which the metrics are
// computed, puts them. Active in development builds and with the URL parameter assertLayout=true.
export function assertLayoutMatches(nodes) {
    const layout = computeLayout(window.psDataset, window.psOrdering, layoutOptions());
    const byPath = new Map(layout.ribbons.map(r => [r.path.join('\0'), r]));
    const close = (a, b) => Math.abs(a - b) <= 1e-9 * Math.max(1, Math.abs(b));
    let failed = nodes.length === layout.ribbons.length ? 0 : 1;
    nodes.forEach(node => {
        const r = byPath.get(node.path);
        const s = node.source, t = node.target;
        if (!r
            || !close(s.node.x + s.x, r.tl[0]) || !close(s.dimension.y, r.tl[1])
            || !close(t.node.x + t.x, r.bl[0]) || !close(t.dimension.y, r.bl[1])
            || !close(t.dx, r.dx) || !close(s.dx, r.dx)) {
            failed++;
        }
    });
    window.layoutAssertions = window.layoutAssertions || { checked: 0, failed: 0 };
    window.layoutAssertions.checked++;
    if (failed > 0) {
        window.layoutAssertions.failed++;
        console.error('Rendered ribbons differ from the layout function (' + failed + ' of ' + nodes.length + ').');
    }
}

let metricsData;
export function updateQmFiledsOnPage(qms) {
    metricsData = qms;

    document.getElementById('qm-overlap').innerHTML = roundTwoDecimals(qms.overlap);
    document.getElementById('qm-slope').innerHTML = roundTwoDecimals(qms.slope);
    document.getElementById('qm-orthogonality').innerHTML = roundTwoDecimals(qms.orthogonality);
    document.getElementById('qm-crossings').innerHTML = roundTwoDecimals(qms.crossings);
    document.getElementById('qm-angle').innerHTML = roundTwoDecimals(qms[metricColumn('crossingAngle', metricVersion)]);

    document.getElementById('qm-ribbons').innerHTML = roundTwoDecimals(qms.relNumRibbons);
    document.getElementById('qm-width-variance').innerHTML = roundTwoDecimals(qms.widthSd);
    document.getElementById('qm-mi').innerHTML = roundTwoDecimals(qms.mutualInfo);

    addValuesToHistories(qms, metricVersion);
}

export function metrics() {
    return metricsData;
}

export function roundTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}

export function roundThreeDecimals(num) {
    return Math.round(num * 1000) / 1000;
}
